import { IStyle, classNamesFunction, IIconStyles } from '@fluentui/react';
import { SubStyle } from './commonStyles';
import { IThemedProp } from './themesUI';

export interface IRequestHeaderStyles {
  iconContainer: IStyle;
  iconBackgroundColorGrey: IStyle;
  iconBackgroundColorBlue: IStyle;
  requestTitle: IStyle;
  requestParatureTicketNumber: IStyle;
  subComponentStyles: {
    requestHeaderIconStyles: SubStyle<IIconStyles>
  }
}

export const getRequestHeaderStyles = (props: IThemedProp): IRequestHeaderStyles => {
  const { theme } = props;
  return {
    iconContainer: {
      borderRadius: '50%',
      height: '24px',
      width: '24px',
      padding: '5px 5px 5px 4px',
      boxSizing: 'border-box',
    },
    iconBackgroundColorGrey: {
      backgroundColor: theme.palette.neutralTertiary,
    },
    iconBackgroundColorBlue: {
      backgroundColor: theme.palette.blue,
    },
    requestTitle: {
      marginLeft: '16px',
      maxWidth: '290px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    requestParatureTicketNumber: {
      padding: '0px 5px 0px 5px',
    },
    subComponentStyles: {
      requestHeaderIconStyles: {
        root: {
          lineHeight: 'normal',
          fontSize: '16px',
          color: '#FFFFFF',
          position: 'absolute',
        },
      },
    },
  };
};

export const getRequestHeaderClassNames = classNamesFunction<{}, IRequestHeaderStyles>();
